// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/access_kind.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/access_kind.proto.
 */
export const file_studyo_today_planners_v1_resources_access_kind = /*@__PURE__*/
  fileDesc("CjRzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL2FjY2Vzc19raW5kLnByb3RvEiJzdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzKmAKCkFjY2Vzc0tpbmQSGwoXQUNDRVNTX0tJTkRfVU5TUEVDSUZJRUQQABIbChdBQ0NFU1NfS0lORF9GVUxMX0FDQ0VTUxABEhgKFEFDQ0VTU19LSU5EX09CU0VSVkVSEAVCKqoCJ1N0dWR5by5Ub2RheS5QbGFubmVycy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.planners.v1.resources.AccessKind.
 */
export const AccessKindSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_planners_v1_resources_access_kind, 0);

/**
 * All possible access rights which can be assigned to a resource, like a planner.
 *
 * @generated from enum studyo.today.planners.v1.resources.AccessKind
 */
export const AccessKind = /*@__PURE__*/
  tsEnum(AccessKindSchema);

